import axios from 'axios'
import { Toast } from 'vant'
// import Cookies from 'js-cookie'
import { clear } from '../utils/token'
const axiosIns = axios.create({
  baseURL: 'https://api-circle.fosun.com', // 请求基础地址
  timeout: 2000000 // 请求响应超时时间
})
// 请求拦截器
axiosIns.interceptors.request.use(
  function (config) {
    // if (Cookies.get('X-Auth')) {
    //   config.headers['X-Auth'] = Cookies.get('X-Auth')
    // }
    if (localStorage.getItem('X-Auth')) {
      const token = localStorage.getItem('X-Auth')
      config.headers['X-Auth'] = JSON.parse(token)
    }
    return config
  }
)
// 响应拦截器
axiosIns.interceptors.response.use(
  function (response) {
    // const data = JSON.stringify(response.data)
    // console.log(`响应拦截数据${data}`)
    // if (response.data.code && response.data.code !== 200) {
    //   clear()
    //   location.replace(location.href)
    // }
    return response.data
  },
  function (error) {
    const { data } = error.response
    if (data.code === 5001 || data.code === 5002) {
      clear()
      location.replace(location.href)
    }
    handlerRequestError()
    // alert('请求失败' + error || '未知错误')
    return Promise.reject(new Error('failed'))
  }
)
function handlerRequestError () {
  // alert('response' + JSON.stringify(error.message))
  // alert('response code' + JSON.stringify(error.code))
  const str = '网络连接异常！多次出现请联系管理员'
  Toast({
    type: 'html',
    className: 'className',
    duration: 0,
    message: `<div  onclick="setTimeout(() => {
      location.href='${location.href}'
    }, 0)" style="width:192px;
      display:flex;
      flex-direction: column;
      align-items: center;
      font-size:16px;
      width: 100vw;
      height: 100vh;
      justify-content: center;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
      line-height:26px;">
      <div style="width: 192px;text-align:center;">${str}</div>
      <buttom style="width:132px;
      height:44px;
      line-height: 44px;
      background:rgba(245,245,245,1);
      border-radius:4px;
      margin-top: 25px;
      display: block;" >刷新</buttom>
    </div>`
  })
}
export default axiosIns
